// Shared so the pricing page can render both the accordion (PricingClient) and
// matching FAQPage JSON-LD (server) from one source.
export const PRICING_FAQ: { q: string; a: string }[] = [
  {
    q: "Do I need a credit card to start?",
    a: "No. Every new account starts with a 14-day full-access trial: no card, and nothing is charged when it ends. After that the Free plan continues forever, and you add a paid plan only when you're ready.",
  },
  {
    q: "What counts as an AI mark-up?",
    a: "One piece of your writing graded by the AI: a practice exercise you submit for feedback, or a full piece marked against an exam rubric. Reading lessons, hints and browsing the library don't count, and nothing is deducted for work you don't submit. Your allowance resets every month.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. Plans are month-to-month (or yearly if you choose). Cancel in a click and you keep access until the period ends.",
  },
  {
    q: "Which exams are included?",
    a: "Exam Prep and Family include every exam module (NSW Selective, NAPLAN, IELTS, TOEFL, and Cambridge English) plus any we add later. Writer covers the full technique library but not the exam modules or timed mock tests.",
  },
  {
    q: "Is my (or my child's) writing private?",
    a: "We use your writing only to coach you. We never sell it or use it to train public models. You can delete it at any time.",
  },
  {
    q: "Can I switch plans later?",
    a: "Anytime. Upgrades apply immediately and we prorate the cost; downgrades take effect at the next renewal.",
  },
  {
    q: "Do you offer family or classroom pricing?",
    a: "Yes. If your household or school needs several seats, get in touch and we'll sort out a plan.",
  },
];
